import { Badge } from '@mantine/core';
import { olcekDizisi } from '../theme';

/**
 * ÖLÇEK ROZETİ — sözleşmenin **İKİNCİ rozet sınıfı** (P8; Kapsam §20.3b,
 * madde 107'nin kod karşılığı).
 *
 * ⚠️ **DURUM KÜMESİ ≠ ÖLÇEK.** `Rozet`in beş anlamı bir **KATEGORİDİR**
 * (engel · dikkat · gecikmiş · bilgi · olumlu) ve her modülde aynıdır.
 * Kademeli şeyler — risk bandı, ileride olay şiddet seviyesi — **ÖLÇEKTİR**:
 * kendi renk dizisini taşırlar ve **dizi kademe sayısına göre değişir**
 * (5x5 dört bant · Fine-Kinney beş). Kademeli bir şeyi durum kümesine
 * sığdıran kod kademeleri birleştirir ve **bilgi kaybeder** — B5'te tam bu
 * olmuştu (`high` ile `unacceptable` ikisi de `engel`e düşmüştü).
 *
 * ⚠️ **BU BİLEŞEN `ROZET_RENGI`Yİ OKUMAZ** ve okumamalıdır: iki sınıfın
 * karışması, birinde yapılan bir renk kararını diğerine sessizce taşır.
 *
 * `kademe` **0 tabanlıdır** ve dizideki sırayı gösterir (0 = en hafif).
 */
export function OlcekRozeti({
  kademe,
  kademeSayisi,
  children,
  testId,
}: {
  kademe: number;
  kademeSayisi: number;
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element {
  const dizi = olcekDizisi(kademeSayisi);
  const renk = dizi[kademe];
  if (renk === undefined) {
    // Fail-loud: diziye sığmayan kademe, sessizce son renge yuvarlanmaz.
    throw new Error(`Ölçek kademesi dizinin dışında: ${kademe}/${kademeSayisi}`);
  }
  return (
    <Badge
      color={renk}
      variant="filled"
      data-testid={testId}
      data-kademe={`${kademe + 1}/${kademeSayisi}`}
    >
      {children}
    </Badge>
  );
}
